
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AutofixAvailable',

  props: {
    autofixFilterApplied: {
      type: Boolean,
      default: false
    }
  },

  emits: ['toggle-autofix-filter']
})
